import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
const browserLanguage = navigator.language

const fallbackLng = 'en-GB'

// All available namespaces - i18next needs to know about them for lazy loading
const allNamespaces = [
  'common',
  'goods',
  'suppliers',
  'settings',
  'dashboard',
  'profile',
  'installations',
  'supplierEmissionsReport',
  'cbamReporting',
  'importers',
  'cbamSimulations',
  'cbamModifiers',
  'inAppNotifications',
  'declarants',
  'userManagement'
]

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    backend: {
      loadPath: '/locale/{{lng}}/{{ns}}.json'
    },
    load: 'currentOnly',
    ns: allNamespaces, // i18next knows about all namespaces
    defaultNS: 'common',
    fallbackLng,
    lng: browserLanguage
  })

// Progressive loading: Load remaining namespaces after page becomes interactive
if (typeof window !== 'undefined') {
  const loadRemainingNamespaces = () => {
    const remainingNamespaces = allNamespaces.filter(ns => ns !== 'common')
    const unloadedNamespaces = remainingNamespaces.filter(ns => !i18n.hasLoadedNamespace(ns))

    if (unloadedNamespaces.length > 0) {
      i18n.loadNamespaces(unloadedNamespaces).catch(console.error)
    }
  }

  // Use requestIdleCallback for non-blocking loading, fallback to setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadRemainingNamespaces, { timeout: 2000 })
  } else {
    // Fallback for browsers that don't support requestIdleCallback
    setTimeout(loadRemainingNamespaces, 100)
  }
}
